import useTranslations from "@/i18n/useTranslations";
import { getCompletionTimeParts } from "./getCompletionTimeText";

export const useCompletionTimeText = () => {
  const t = useTranslations("Course");

  return (
    weeksToComplete?: number,
    includeToComplete: boolean = true,
  ): string | null => {
    const parts = getCompletionTimeParts(weeksToComplete);
    if (!parts) return null;

    if (parts.unit === "weeks") {
      return includeToComplete
        ? t("weeksToComplete", { count: parts.count })
        : t("weeksCount", { count: parts.count });
    }

    return includeToComplete
      ? t("monthsToComplete", { count: parts.count })
      : t("monthsCount", { count: parts.count });
  };
};
